import {
  isValidTypeaheadCategory,
  isValidTypeaheadCategoryV8
} from '@kyruus/search-widget-v2';
import type {
  ValidTypeaheadCategory,
  ValidV8TypeaheadCategory
} from '@kyruus/search-widget-v2';

export type TypeaheadCategoryKey =
  | ValidTypeaheadCategory
  | ValidV8TypeaheadCategory;

export type TypeaheadCategoryEntry = [TypeaheadCategoryKey, string];

/**
 * Finds the `[key, value]` entry for the first valid typeahead category
 * (v9 or v8) present in the given query params.
 * There should only ever be one valid typeahead category in the query params.
 */
export const getTypeaheadCategoryEntry = (
  queryParams: URLSearchParams
): TypeaheadCategoryEntry | undefined =>
  Array.from(queryParams.entries()).find(
    (entry): entry is TypeaheadCategoryEntry =>
      isValidTypeaheadCategory(entry[0]) || isValidTypeaheadCategoryV8(entry[0])
  );
